import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState, useMemo } from "react";
import { useHistory } from "react-router-dom";
import ConfirmDocument from "../../components/ConfirmDocument/ConfirmDocument";
import Navbar from "../../components/Navbar/Navbar";
import PayPalCheckoutCart from "../../components/PayPalCheckoutCart/PayPalCheckoutCart";
import { useToastContext } from "../../contexts/ToastContext/ToastContext";
import ShoppingCartContent from "./ShoppingCartContent";
import localeText from "../../locale";
import GetInfoService from "../../service/GetInfoService";
import GetUserInfoService from "../../service/GetUserInfoService";
import OrderService from "../../service/OrderService";
import ProductService from "../../service/ProductService";
import useUserType from "../../hooks/useUserType";
import useOrderCount from "../../hooks/useOrderCount";
import { removelocalStorageToken } from "../../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../../utilities/sessionStorage/username";
import CartItems from "./components/CartItems/CartItems";
import Checkout from "./components/Checkout/Checkout";
import { Toast } from "primereact/toast";
import ThankYouPage from "./components/ThankYouPage/ThankYouPage";
import ErrorCheckout from "./components/ErrorCheckout/ErrorCheckout";
import paypalImg from "../../pages/images/paypal.png";
import masterCardImg from "../../pages/images/masterCard.png";
import americanExpress from "../../pages/images/expressoAmericano.png";
import visa from "../../pages/images/visa.png";
import PagamentoSeguro from "../../pages/images/pagamentoSeguro.png";
import LandingFooter from "../Landing/components/LandingFooter/LandingFooter";
import LandingCopyright from "../Landing/components/LandingCopyright/LandingCopyright";
import "./ShoppingCart.css";
import { useLocation } from "react-router-dom";
import ShippingCheckout from "./components/Shipping/ShippingCheckout";
import { PaymentProvider } from "./components/Checkout/context/PaymentContext";
import Loading from "../../components/Loading/Loading";
import { useAuthDialog } from "../../contexts/AuthDialogContext/AuthDialogContext";

const parseOrder = (order, isFringeBenefitsPage) => {
  let orderParsed = JSON.parse(order);

  if (isFringeBenefitsPage) return !!!orderParsed?.fringeBenefit;

  return !!!orderParsed?.itens[0];
};

const ShoppingCart = () => {
  const location = useLocation();
  const { userType } = useUserType();
  const { orderCount } = useOrderCount();
  const { openLoginDialog } = useAuthDialog();
  const productService = new ProductService();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const orderKey = isFringeBenefitsPage
    ? "__extraconomy_order_fringe_benefit"
    : "__extraconomy_order";

  const [loading, setLoading] = useState(false);
  const [orderItems, setOrderItems] = useState([]);
  const [currencyProduct, setCurrencyProduct] = useState("");
  const [currencyUser, setCurrencyUser] = useState("");
  const [amountTransfer, setAmountTransfer] = useState(null);
  const [walletBalance, setWalletBalance] = useState(null);
  const [walletBalanceForex, setWalletBalanceForex] = useState(null);
  const [walletExtracoinBalance, setWalletExtracoinBalance] = useState(null);
  const [walletExtracoinBalanceForex, setWalletExtracoinBalanceForex] = useState(null);
  const [isLoadingWalletExtracoinBalanceForex, setIsLoadingWalletExtracoinBalanceForex] =
    useState(true);
  const [cashback, setCashback] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("USD");
  const [currencyCodeUser, setCurrencyCodeUser] = useState("USD");
  const [price, setPrice] = useState(0);
  const [priceForex, setPriceForex] = useState(0);
  const [displayPaymentModal, setDisplayPaymentModal] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [addressInfo, setAddressInfo] = useState(null);
  const [amountWallet, setAmountWallet] = useState(null);
  const [userPercentExtracoin, setUserPercentExtracoin] = useState(null);
  const [isFreeExtracoin, setIsFreeExtracoin] = useState(false);
  const [isLoadingIsFreeExtracoin, setIsLoadingIsFreeExtracoin] = useState(true);
  const [sendMethod, setSendMethod] = useState(null);
  const [amountToPayWithExtracredit, setAmountToPayWithExtracredit] = useState(null);
  const [amountBankTransfer, setAmountBankTransfer] = useState(null);
  const [bankTransferReceipt, setBankTransferReceipt] = useState(null);
  const [currencyExchangeValue, setCurrencyExchangeValue] = useState(1);
  const { showErrorToast } = useToastContext();
  const [idTransaction, setIdTransaction] = useState(null);
  const [order, setOrder] = useState(() => {
    const storedOrder = localStorage.getItem(orderKey);
    if (storedOrder) {
      return JSON.parse(storedOrder);
    }
    return null;
  });
  const [isLoadingOrder, setIsLoadingOrder] = useState(true);
  const [orderIsEmpty, setOrderIsEmpty] = useState(() => {
    const storedOrder = localStorage.getItem(orderKey);
    return parseOrder(storedOrder, isFringeBenefitsPage);
  });
  const [amountShipmentForexProduct, setAmountShipmentForexProduct] = useState(0);
  const [idProductCartProcessed, setIdProductCartProcessed] = useState(false);

  const userInfoService = new GetUserInfoService();
  const getInfoService = new GetInfoService();
  const getUserInfoService = new GetUserInfoService();

  const history = useHistory();
  const toast = useRef(null);

  useEffect(() => {
    const handleStorageChange = () => {
      const storedOrder = localStorage.getItem(orderKey);
      if (storedOrder) {
        const parsedOrder = JSON.parse(storedOrder);
        if (JSON.stringify(parsedOrder) !== JSON.stringify(order)) {
          setOrder(parsedOrder);
          setOrderIsEmpty(parseOrder(storedOrder, isFringeBenefitsPage));
        }
      }
    };

    const interval = setInterval(handleStorageChange, 1000);

    window.addEventListener('storage', handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [order, orderKey, isFringeBenefitsPage]);

  useEffect(() => {
    if (idProductCartProcessed) return;
    if (localStorage.getItem("__extraconomy_token")) return;

    const searchParams = new URLSearchParams(location.search);
    const idProductCart = searchParams.get("idProductCart");

    if (!idProductCart) return;

    const processIdProductCart = async () => {
      try {
        const existingOrder = localStorage.getItem(orderKey);
        let productAlreadyInCart = false;

        if (existingOrder) {
          const parsedOrder = JSON.parse(existingOrder);
          if (parsedOrder?.isGuestCart && parsedOrder?.itens?.length > 0) {
            productAlreadyInCart = parsedOrder.itens.some(
              (item) => String(item.product?.id) === String(idProductCart)
            );
          }
        }

        if (!productAlreadyInCart) {
          const productRes = await productService.getProductById(idProductCart);
          if (productRes?.messageCode === 200001 && productRes?.result?.product) {
            const productData = productRes.result;
            const priceUnitary = productData.product.promotionalPriceUnique || productData.product.priceUnique;

            if (existingOrder) {
              const parsedOrder = JSON.parse(existingOrder);
              if (parsedOrder?.isGuestCart) {
                parsedOrder.itens.push({
                  product: productData.product,
                  productVariation: null,
                  quantity: 1,
                  priceUnitary,
                  totalItem: priceUnitary,
                  percentualExtraCoin: 0,
                  shareToken: null,
                });
                parsedOrder.amountOrder = parsedOrder.itens.reduce((sum, item) => sum + item.totalItem, 0);
                localStorage.setItem(orderKey, JSON.stringify(parsedOrder));
                setOrder(parsedOrder);
                setOrderItems(parsedOrder.itens);
              }
            } else {
              const newGuestOrder = {
                itens: [{
                  product: productData.product,
                  productVariation: null,
                  quantity: 1,
                  priceUnitary,
                  totalItem: priceUnitary,
                  percentualExtraCoin: 0,
                  shareToken: null,
                }],
                amountOrder: priceUnitary,
                isGuestCart: true,
              };
              localStorage.setItem(orderKey, JSON.stringify(newGuestOrder));
              setOrder(newGuestOrder);
              setOrderItems(newGuestOrder.itens);
            }
          }
        }

        setIdProductCartProcessed(true);
        openLoginDialog(true);
      } catch (e) {
        setIdProductCartProcessed(true);
        openLoginDialog(true);
      }
    };

    processIdProductCart();
  }, [location.search, orderKey, idProductCartProcessed]);

  useEffect(() => {
    if (userType && orderCount !== null) {
      if (
        (userType === "Customer" || userType === "Promoter") &&
        orderCount < 3
      ) {
        setIsFreeExtracoin(true);
      }
      setIsLoadingIsFreeExtracoin(false);
    } else if (!localStorage.getItem("__extraconomy_token")) {
      setIsLoadingIsFreeExtracoin(false);
    }
  }, [userType, orderCount]);

  const orderService = new OrderService();

  const populateOrder = () => {
    if (order?.isGuestCart) {
      setOrderItems(order?.itens || []);
      setOrderIsEmpty(!order?.itens || order.itens.length === 0);
      setIsLoadingOrder(false);
      return;
    }

    if (
      order &&
      userPercentExtracoin !== null &&
      userPercentExtracoin !== undefined &&
      !isLoadingWalletExtracoinBalanceForex &&
      !isLoadingIsFreeExtracoin
    ) {
      if (isFreeExtracoin) {
        if (order?.itens?.length > 0) {
          setOrderItems(order?.itens);
          setOrderIsEmpty(false);
        }
        setOrder(order);
        setIsLoadingOrder(false);
      } else {
        if (order?.itens?.length > 0) {
          let totalExtracoinAvaible;

          if (walletExtracoinBalanceForex) {
            totalExtracoinAvaible = (walletExtracoinBalanceForex * userPercentExtracoin) / 100;
          } else {
            totalExtracoinAvaible = (walletExtracoinBalance * userPercentExtracoin) / 100;
          }

          order.itens.forEach(async (item, index) => {
            const totalToPayWithExtracoin = item.totalItem * (item.product.percentExtraCoin / 100);
            const totalToPay = item.totalItem;
            setCashback((prev) => prev + item.cashback);

            const isPossibleUseExtracoin = totalExtracoinAvaible / totalToPay;

            if (isPossibleUseExtracoin >= item.product.percentExtraCoin / 100) {
              totalExtracoinAvaible = totalExtracoinAvaible - totalToPayWithExtracoin;
              orderService
                .postEditItem(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                  item.id,
                  item.product.percentExtraCoin,
                  item.quantity
                )
                .then((res) => {
                  setOrder(res?.result);
                  setOrderItems(res?.result?.itens);
                })
                .finally(() => {
                  if (index === order.itens.length - 1) setIsLoadingOrder(false);
                });
            } else if (isPossibleUseExtracoin > 0 && isPossibleUseExtracoin < 1) {
              totalExtracoinAvaible = 0;
              const percent = Math.floor(isPossibleUseExtracoin * 100);
              orderService
                .postEditItem(
                  localStorage.getItem("__extraconomy_token"),
                  localStorage.getItem("__extraconomy_username"),
                  item.id,
                  percent,
                  item.quantity
                )
                .then((res) => {
                  setOrder(res.result);
                  setOrderItems(res.result.itens);
                })
                .finally(() => {
                  if (index === order.itens.length - 1) setIsLoadingOrder(false);
                });
            } else {
              setOrderItems(order.itens);
              if (index === order.itens.length - 1) setIsLoadingOrder(false);
            }
          });
        }
        setOrder(order);
        setIsLoadingOrder(false);
      }
    }
  };

  useEffect(() => {
    if (!order) {
      populateOrder();
      return;
    }

    if (order.isGuestCart) {
      setOrderItems(order.itens || []);
      setIsLoadingOrder(false);
      return;
    }

    if (order.itens) {
      setOrderItems(order.itens);
      if (
        !isLoadingWalletExtracoinBalanceForex &&
        userPercentExtracoin !== null &&
        userPercentExtracoin !== undefined &&
        !isLoadingIsFreeExtracoin
      ) {
        setIsLoadingOrder(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingWalletExtracoinBalanceForex, userPercentExtracoin, isLoadingIsFreeExtracoin, order]);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        if (order) {
          const orderCurrency = order?.itens?.[0]?.product?.currency
            ? order.itens[0].product.currency
            : order.fringeBenefit?.currency;

          if (orderCurrency) {
            setCurrencyProduct(orderCurrency);
            setCurrencyCode(orderCurrency);
          } else {
            setCurrencyProduct("USD");
            setCurrencyCode("USD");
          }

          if (localStorage.getItem("__extraconomy_token")) {
            const res = await userInfoService.getWalletInfo(
              localStorage.getItem("__extraconomy_token"),
              localStorage.getItem("__extraconomy_username")
            );
            if (cancel) return;

            let resForex = 1;

            if (res.messageCode !== 200001) {
              showErrorToast({ code: res.messageCode });
            } else {
              setCurrencyUser(res.result.currency);
              setCurrencyCodeUser(res.result.currency);
              setWalletBalance(res.result.balance);

              if (orderCurrency !== res.result.currency) {
                resForex = await getInfoService.getForexRate(res.result.currency, orderCurrency);

                if (resForex.messageCode !== 200001) {
                  showErrorToast({ code: resForex.messageCode });
                } else {
                  setCurrencyExchangeValue(resForex.result);
                  setWalletBalanceForex(res.result.balance * resForex.result);
                }
              }
            }

            const resExtracoin = await getUserInfoService.getExtracoinInfo(
              localStorage.getItem("__extraconomy_token"),
              localStorage.getItem("__extraconomy_username")
            );

            if (resExtracoin.messageCode !== 200001) {
              showErrorToast({ code: resExtracoin.messageCode });
            } else {
              setWalletExtracoinBalance(resExtracoin.result.balance);

              if (orderCurrency !== resExtracoin.result.currency) {
                setWalletExtracoinBalanceForex(resExtracoin.result.balance * resForex.result);
              }
            }
          }

          setIsLoadingWalletExtracoinBalanceForex(false);
        } else {
          setIsLoadingOrder(false);
          setOrderIsEmpty(true);
          setIsLoadingWalletExtracoinBalanceForex(false);
        }
      } catch (e) {
      }
    }

    fetchData();

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        const token = localStorage.getItem("__extraconomy_token");
        const username = localStorage.getItem("__extraconomy_username");

        const res = await getUserInfoService.getExtracoinPercentage(
          token,
          username
        );
        if (cancel) return;

        const resUser = await getUserInfoService.getUserInfo(
          token,
          username
        );

        if (res.messageCode !== 200001) {
          showErrorToast({ code: res.messageCode });
          return false;
        }

        if (resUser.messageCode !== 200001) {
          showErrorToast({ code: resUser.messageCode });
          return false;
        }

        setUserPercentExtracoin(res.result.percent);

        setUserInfo(resUser?.result?.user);
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          removelocalStorageToken();
          removelocalStorageUsername();
          history.push("/login");
        }
      }
    }

    if (
      localStorage.getItem("__extraconomy_token") &&
      localStorage.getItem("__extraconomy_username")
    ) {
      fetchData();
    } else {
      setUserPercentExtracoin(0);
    }

    return () => {
      cancel = true;
    };
  }, [order]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const currencyFormat = useMemo(() => ({
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  }), []);

  const memoizedOrderConfig = useMemo(() => {
    const calculatedOrderTotal = isFringeBenefitsPage
      ? order?.totalOrder
      : (order?.amountOrder || 0) +
        (order?.amountShipment && order.amountShipment > 0 ? order.amountShipment : 0) +
        (order?.amountToPlatform || 0);

    return {
      order,
      orderTotal: calculatedOrderTotal,
      sendMethod,
      currencyProduct,
      amountShipmentForexProduct,
      isFringeBenefitsPage,
      setOrder,
      setPrice,
      walletBalanceForex,
      walletBalance,
      currencyCodeUser,
      extracoinInWallet: walletExtracoinBalanceForex
        ? walletExtracoinBalanceForex * (userPercentExtracoin / 100)
        : walletExtracoinBalance * (userPercentExtracoin / 100),
      walletExtracoinBalance,
      walletExtracoinBalanceForex,
      userPercentExtracoin,
      userInfo,
      isLoadingWalletExtracoinBalanceForex,
    };
  }, [
    order,
    sendMethod,
    currencyProduct,
    amountShipmentForexProduct,
    isFringeBenefitsPage,
    setOrder,
    setPrice,
    walletBalanceForex,
    walletBalance,
    currencyCodeUser,
    walletExtracoinBalanceForex,
    walletExtracoinBalance,
    userPercentExtracoin,
    userInfo,
    isLoadingWalletExtracoinBalanceForex,
  ]);

  return (
    <>
      {userInfo || order?.isGuestCart || (!localStorage.getItem("__extraconomy_token") && !isLoadingWalletExtracoinBalanceForex) ? (
        <PaymentProvider orderConfig={memoizedOrderConfig} currencyFormat={currencyFormat}>
          <ShoppingCartContent
            order={order}
            orderItems={orderItems}
            cashback={cashback}
            setOrder={setOrder}
            setCashback={setCashback}
            isLoadingOrder={isLoadingOrder}
            currencyProduct={currencyProduct}
            currencyCodeUser={currencyCodeUser}
            currencyUser={currencyUser}
            setPrice={setPrice}
            setOrderItems={setOrderItems}
            walletExtracoinBalance={walletExtracoinBalance}
            userPercentExtracoin={userPercentExtracoin}
            walletExtracoinBalanceForex={walletExtracoinBalanceForex}
            setOrderIsEmpty={setOrderIsEmpty}
            orderIsEmpty={orderIsEmpty}
            isLoadingWalletExtracoinBalanceForex={isLoadingWalletExtracoinBalanceForex}
            amountShipmentForexProduct={amountShipmentForexProduct}
            setAmountShipmentForexProduct={setAmountShipmentForexProduct}
            setAmountTransfer={setAmountTransfer}
            amountTransfer={amountTransfer}
            setLoading={setLoading}
            amountWallet={amountWallet}
            currencyExchangeValue={currencyExchangeValue}
            amountToPayWithExtracredit={amountToPayWithExtracredit}
            setAmountToPayWithExtracredit={setAmountToPayWithExtracredit}
            amountBankTransfer={amountBankTransfer}
            setAmountBankTransfer={setAmountBankTransfer}
            bankTransferReceipt={bankTransferReceipt}
            setBankTransferReceipt={setBankTransferReceipt}
            walletBalance={walletBalance}
            walletBalanceForex={walletBalanceForex}
            price={price}
            currencyCode={currencyCode}
            setAmountWallet={setAmountWallet}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setAddressInfo={setAddressInfo}
            setPriceForex={setPriceForex}
            setDisplayPaymentModal={setDisplayPaymentModal}
            sendMethod={sendMethod}
            setSendMethod={setSendMethod}
            isFringeBenefitsPage={isFringeBenefitsPage}
            idTransaction={idTransaction}
            showErrorToast={showErrorToast}
          />
        </PaymentProvider>
      ) : (
        <div><Loading /></div>
      )}
    </>
  );
};

export default ShoppingCart;
